module.exports = __webpack_public_path__ + "static/media/1_Normal_AP_Z1.1a4b5fbd.png";